import { getDefaultURLSearchRequest, URL_KEYS } from '@travel/traveler-core/utils/jrdpHelper';
import { isEmptyObject } from '@travel/utils';

import { fetchPlanDetails } from 'store/planDetails/actions';
import { fetchProviderDetails, fetchSEOData } from 'store/providerDetails/actions';

import { fetchBanner } from 'store/banner/actions';

import { URLSearchQuery } from 'Common-Types';
import { universalRouterProps } from 'core/universalRouter/types';
import { RequestBody } from 'PlanDetails-Types';
import { getDefaultURLCustomListRequest, getPlanDetailValidSortValue } from 'utils/search';

export type URLParams = { providerId: string; planId: string; itemId?: string };

const DEFAULT_LIMIT = 10;

export default async (
  { store: { dispatch, getState } }: universalRouterProps,
  params: URLParams,
  urlParams: URLSearchQuery,
) => {
  const itemId = params.itemId?.replace(/\/+$/, '');
  const query: RequestBody = {
    ...getDefaultURLSearchRequest(urlParams),
    ...getDefaultURLCustomListRequest(urlParams),
    id: params.providerId,
    planId: params.planId,
    itemId: itemId ? itemId : undefined,
    offset: 0,
    limit: DEFAULT_LIMIT,
    sort: getPlanDetailValidSortValue(urlParams?.[URL_KEYS.SORT]),
  };

  await Promise.all([
    dispatch(fetchBanner()),
    dispatch(fetchProviderDetails(params?.providerId)),
    dispatch(fetchPlanDetails(query)),
  ]);

  const state = getState();
  const { planDetails } = state;
  const planDetailsImgUrl = !isEmptyObject(planDetails.planDetails)
    ? planDetails.planDetails.media[0]?.url
    : '';

  return dispatch(fetchSEOData(planDetailsImgUrl));
};
